export const window = global;

export const { fetch, console, FormData, document } = global;
